module.exports = __webpack_public_path__ + "static/donovanheadshot-8d1e8c4df80931299cb3f316f3b912bf.jpg";